export const darkDatePickerSlotProps = {
  textField: {
    fullWidth: true,
    sx: {
      "& .MuiInputLabel-root": {
        color: "#fff !important",
      },

      "& .MuiPickersOutlinedInput-root": {
        color: "#fff !important",
        "& fieldset": {
          borderColor: "#777 !important",
        },
        "&:hover fieldset": {
          borderColor: "hsl(19 100% 50%) !important",
        },
        "&.Mui-focused fieldset": {
          borderColor: "hsl(19 100% 50%) !important",
        },
      },

      "& .MuiPickersOutlinedInput-input": {
        color: "#fff !important",
      },

      "& .MuiSvgIcon-root": {
        color: "#fff !important",
      },
    },
  },
};
